import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { VideoRecorder, VideoRecorderCamera, VideoRecorderPreviewFrame } from '@capacitor-community/video-recorder';
import { FileService } from 'src/app/services/app/file.service';
import { blobTo64 } from 'src/app/utils/utils';
import { HttpService } from 'src/app/services/app/http.service';
import { firstValueFrom } from 'rxjs';
import { Camera } from '@capacitor/camera';


@Component({
  selector: 'app-c-modal-record-video',
  templateUrl: './c-modal-record-video.component.html',
  styleUrls: ['./c-modal-record-video.component.scss'],
})
export class CModalRecordVideoComponent implements AfterViewInit, OnDestroy {
  recording = false;
  timeLimit = 30;
  timeOut: any;
  trackTimeRecordingInterval: any;
  timeRecording = 0;

  config: VideoRecorderPreviewFrame = {
    id: 'video-record',
    stackPosition: 'back', // 'front' overlays your app', 'back' places behind your app.
    width: 'fill',
    height: 'fill',
    x: 0,
    y: 0,
    borderRadius: 0
  };

  constructor(
    private alertController: AlertController,
    private fileService: FileService,
    private httpService: HttpService,
    private modalController: ModalController,
  ) { }

  requestVideoRecordingPermission() {
    return Camera.checkPermissions().then(e => {
      if (e.camera === 'granted') {
        return true
      } else if (e.camera === 'prompt' || e.camera === 'prompt-with-rationale') {
        return Camera.requestPermissions().then(res => {
          if (res.camera === 'granted') {
            return true
          }
          return `Vous n'avez pas autorisé l'appareil à prendre des vidéos.`;
        })
      }
      return `Vous n'avez pas autorisé l'appareil à prendre des vidéos.`;
    }).catch(err => {
      return `Votre appareil ne vous permet pas de prendre des enregistrements vidéo.`;
    })
  }


  public ngAfterViewInit(): void {
    this.requestVideoRecordingPermission().then(_ => {
      if (typeof _ === 'string') {
        this.closeModal();
        this.alertController.create({
          message: _,
          buttons: [
            {
              text: `OK`,
            }
          ]
        }).then(alrt => alrt.present())
      } else {
        document.querySelector('body')?.classList.add('video-recording-active');
        VideoRecorder.initialize({
          camera: VideoRecorderCamera.BACK,
          previewFrames: [this.config]
        })
          .then(_ => console.log(_))
          .catch(err => console.log('ERR', err))
      }
    })
  }

  public ngOnDestroy(): void {
    document.querySelector('body')?.classList.remove('video-recording-active');
  }

  startRecording() {
    if (this.recording) {
      return;
    }
    this.timeRecording = 0;
    VideoRecorder.startRecording().then(e => {
      this.recording = true
      this.timeOut = setTimeout(() => {
        this.stopRecording();
      }, this.timeLimit * 1000);
      this.trackTimeRecordingInterval = setInterval(() => {
        this.timeRecording += 100;
      }, 100);
    })

  }

  stopRecording() {
    if (!this.recording) {
      return;
    }
    this.recording = false;
    if (this.timeOut) {
      clearTimeout(this.timeOut);
      this.timeOut = undefined;
    }
    if (this.trackTimeRecordingInterval) {
      clearInterval(this.trackTimeRecordingInterval);
      this.trackTimeRecordingInterval = undefined;
    }
    const stopRecordingP = VideoRecorder.stopRecording();

    if (stopRecordingP !== undefined) {
      stopRecordingP.then((result: { videoUrl: string }) => {
        this.treatVideoFile(result).then(infos => {
          this.closeModal(infos);
        })
      })
    }
  }

  cancelRecording() {
    this.recording = false;
    if (this.timeOut) {
      clearTimeout(this.timeOut);
      this.timeOut = undefined;
    }
    if (this.trackTimeRecordingInterval) {
      clearInterval(this.trackTimeRecordingInterval);
      this.trackTimeRecordingInterval = undefined;
    }
    VideoRecorder.stopRecording();
    this.closeModal();
  }

  public async closeModal(infos?: any): Promise<void> {
    this.modalController.dismiss(infos);
  }

  treatVideoFile(filetoTreat: { videoUrl: string }): Promise<{ filePath: string, fullDataBase64: string }> {
    return firstValueFrom(this.httpService.downloadMedia(filetoTreat.videoUrl))
    .then(res => blobTo64(res).then(dataBase64 => ({dataBase64, mimeType: res.type})))
    .then(({dataBase64, mimeType }) => this.fileService.copyInCache(dataBase64, this.urlIntoName(filetoTreat.videoUrl))
      .then(result => ({
        filePath: result.uri,
        fullDataBase64: dataBase64
      }))
    )
  }

  urlIntoName(videoUrl: string) {
    return videoUrl.split('/').reverse()[0];
  }

}
